import * as React from "react";
import { Button, Classes, Intent } from "@focus/focusUI";
import { getUiProperties } from "../utils/utils";
import { getNumericValueFromString, isValidInteger, getValueOrDefault, isOverMaxLength, isNotADisplacementKey, isGreateMaxLength, isNotNaN, } from "./utils";
import { changeFromSchemaAndValue } from "../entities/formData";
export class NumericInteger extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.incrementValue = () => {
            const incremented = getNumericValueFromString(this.state.stringValue) + 1;
            this.handleValueChange(incremented, incremented + "", this.state.cursorPointer);
        };
        this.decrementValue = () => {
            const decremented = getNumericValueFromString(this.state.stringValue) - 1;
            this.handleValueChange(decremented, decremented + "", this.state.cursorPointer);
        };
        this.onChange = (event) => {
            this.handleValueChange(event.target.value, event.target.value + "", event.target.selectionStart);
        };
        this.onKeyUp = (event) => {
            const key = event.key;
            if (key.includes("Arrow")) {
                this.setState({
                    cursorPointer: this.inputRef.current.selectionStart,
                });
            }
            else if (key !== "Enter" && key !== "Backspace" && key !== "Tab") {
                this.inputRef.current.selectionStart = this.state.cursorPointer;
                this.inputRef.current.selectionEnd = this.state.cursorPointer;
            }
        };
        this.checkIntegerInput = (value) => (e) => {
            if (!e.ctrlKey &&
                !e.metaKey &&
                isNotADisplacementKey(e.key) &&
                (isGreateMaxLength(this.props.schema, value) ||
                    (!e.key.match(/[0-9]/) &&
                        !(e.key.match(/[+-]/) && !value.match(/[+-]/))))) {
                e.preventDefault();
            }
        };
        this.handleValueChange = (_valueAsNumber, _valueAsString, cursorPointer) => {
            let parsedValue = _valueAsString;
            if (isGreateMaxLength(this.props.schema, _valueAsString)) {
                parsedValue = _valueAsString.slice(0, this.props.schema.maxLength);
                if (isValidInteger(parsedValue)) {
                    this.props.notify({
                        message: `${_valueAsString} has been truncated to ${parsedValue}`,
                        intent: Intent.WARNING,
                    });
                }
                else {
                    this.props.notify({
                        message: `${_valueAsString} cannot be truncated to to an integer of maximum length ${this.props.schema.maxLength}`,
                        intent: Intent.DANGER,
                    });
                    return;
                }
            }
            if (isValidInteger(parsedValue)) {
                if (typeof cursorPointer === "undefined") {
                    this.setState({ stringValue: parsedValue });
                }
                else {
                    this.setState({ stringValue: parsedValue, cursorPointer });
                }
                const value = getNumericValueFromString(parsedValue);
                this.props.onChange(value, changeFromSchemaAndValue(this.props.schema, value));
            }
        };
        this.handleButtonClick = (_valueAsNumber, _valueAsString) => {
            if (!isOverMaxLength(this.props.schema, _valueAsString)) {
                this.setState({ stringValue: _valueAsString });
                this.props.onChange(_valueAsNumber, changeFromSchemaAndValue(this.props.schema, _valueAsNumber));
            }
        };
        this.state = {
            stringValue: getValueOrDefault(props),
            cursorPointer: 0,
        };
    }
    componentDidUpdate(prevProps) {
        if (isNotNaN(this.props.formData) &&
            prevProps.formData !== this.props.formData &&
            this.props.formData != getNumericValueFromString(this.state.stringValue)) {
            this.setState({
                stringValue: getValueOrDefault(this.props),
            });
        }
    }
    componentDidMount() {
        let value = isNotNaN(this.props.formData)
            ? this.props.formData.toString()
            : "";
        if (value === "" ||
            !isValidInteger(value) ||
            typeof this.props.formData === "object") {
            const value = getNumericValueFromString(this.state.stringValue);
            this.props.onChange(value, changeFromSchemaAndValue(this.props.schema, value));
        }
    }
    render() {
        const { schema, uiSchema } = this.props;
        const { isDisabled, isReadOnly } = getUiProperties(uiSchema);
        let value = this.state.stringValue;
        const min = schema.minimum ||
            (!isNaN(schema.maxLength) && -Number(`1e${schema.maxLength - 1}`) + 1) ||
            null;
        const max = schema.maximum ||
            (!isNaN(schema.maxLength) && Number(`1e${schema.maxLength}`) - 1) ||
            null;
        return (React.createElement("div", { className: `${Classes.NUMERIC_INPUT} ${Classes.CONTROL_GROUP}` },
            React.createElement("div", { className: Classes.INPUT_GROUP },
                React.createElement("input", { ref: this.inputRef, className: Classes.INPUT, type: "text", value: value, min: min, max: max, disabled: isDisabled, readOnly: isReadOnly, onKeyDown: this.checkIntegerInput(value), onChange: (event) => this.onChange(event), onKeyUp: this.onKeyUp })),
            React.createElement("div", { className: `${Classes.BUTTON_GROUP} ${Classes.VERTICAL} ${Classes.FIXED}` },
                React.createElement(Button, { disabled: isDisabled || isReadOnly, active: isReadOnly, icon: "chevron-up", minimal: true, small: true, onClick: () => this.incrementValue(), "aria-label": "up" }),
                React.createElement(Button, { disabled: isDisabled || isReadOnly, active: isReadOnly, icon: "chevron-down", minimal: true, small: true, onClick: () => this.decrementValue(), "aria-label": "down" }))));
    }
}
//# sourceMappingURL=NumericInteger.js.map